const stationary_combustion = "Stationary combustion";
const mobile_sources = "Mobile sources";
const refrigeration_and_fire_suppression = "Refrigeration and fire suppression";
const purchased_gases = "Purchased gases";

const electricity = "Electricity";
const steam = "Steam";

const purchased_goods_and_services = "1. Purchased goods and services";
const capital_goods = "2. Capital goods";
const fuel_and_energy_related_activities = "3. Fuel and energy-related activities";
const upstream_transportation_and_distribution = "4. Upstream transportation and distribution";
const waste_generated_in_operations = "5. Waste generated in operations";
const business_travel = "6. Business travel";
const employee_commuting = "7. Employee commuting";
const upstream_leased_assets = "8. Upstream leased assets";
const downstream_transportation_and_distribution = "9. Downstream transportation and distribution";
const processing_of_sold_products = "10. Processing of sold products";
const use_of_sold_products = "11. Use of sold products";
const end_of_life_treatment_of_sold_products = "12. End-of-life treatment of sold products";
const downstream_leased_assets = "13. Downstream leased assets";

const franchises = "14. Franchises";
const investments = "15. Investments";

const beyond_value_chain = "Beyond value chain";

const fuel_based = "Fuel based";
const distance_based = "Distance based";
const purchase_based = "Purchase based";
const location_based = "Location based";
const market_based = "Market based";
const material_balance = "Material balance";
const asset_specific = "Asset specific";
const site_specific = "Site specific";
const average_data = "Average data";
const direct_use_phase = "Direct use-phase";
const indirect_use_phase = "Indirect use-phase";
const waste_type_specific = "Waste type specific";
const industrial_process = "Industrial Process";

const energy_sources = "Energy sources";
const transport = "Transport";
const reagent = "Reagent";
const machinery_and_equipment = "Machinery & Equipment";
const metals = "Metals";
const paper = "Paper";
const board = "Board";
const polymers = "Polymers";
const waste_treatment = "Waste Treatment";
const wood = "Wood";
const common_building_materials = "Common Building Materials";
const freight_transport = "Freight Transport";
const passenger_transport = "Passenger Transport";
const other = "Other";
const general_materials = [board, common_building_materials, machinery_and_equipment, metals, paper, polymers, waste_treatment, wood];

export const scope1Categories = [stationary_combustion, mobile_sources, refrigeration_and_fire_suppression, purchased_gases];
export const scope2Categories = [electricity, steam];
export const scope3CategoriesForSupplyChain = [
  purchased_goods_and_services,
  capital_goods,
  fuel_and_energy_related_activities,
  upstream_transportation_and_distribution,
  waste_generated_in_operations,
  business_travel,
  employee_commuting,
  upstream_leased_assets,
  downstream_transportation_and_distribution,
  processing_of_sold_products,
  use_of_sold_products,
  end_of_life_treatment_of_sold_products,
  downstream_leased_assets,
];
export const scope3Categories = [...scope3CategoriesForSupplyChain, franchises, investments];
export const scope4Categories = [beyond_value_chain];
export const allCategoriesForSupplyChain = [...scope1Categories, ...scope2Categories, ...scope3CategoriesForSupplyChain];
export const allCategories = [...scope1Categories, ...scope2Categories, ...scope3Categories];

export const supplychainEmissionDetailMap = {
  [stationary_combustion]: { [fuel_based]: [energy_sources] },
  [mobile_sources]: { [fuel_based]: [transport], [distance_based]: [transport] },
  [refrigeration_and_fire_suppression]: { [material_balance]: [reagent] },
  [purchased_gases]: { [purchase_based]: [reagent] },

  [electricity]: { [location_based]: { [energy_sources]: [electricity] }, [market_based]: { [energy_sources]: [electricity] } },
  [steam]: { [location_based]: { [energy_sources]: { [other]: { [industrial_process]: [steam] } } } },

  [purchased_goods_and_services]: { [average_data]: [...general_materials] },
  [capital_goods]: { [average_data]: [machinery_and_equipment] },
  [fuel_and_energy_related_activities]: { [average_data]: [energy_sources] },
  [upstream_transportation_and_distribution]: {
    [fuel_based]: { [transport]: [freight_transport] },
    [distance_based]: { [transport]: [freight_transport] },
  },
  [waste_generated_in_operations]: { [waste_type_specific]: [waste_treatment] },
  [business_travel]: {
    [fuel_based]: { [transport]: [passenger_transport] },
    [distance_based]: { [transport]: [passenger_transport] },
  },
  [employee_commuting]: {
    [fuel_based]: { [transport]: [passenger_transport] },
    [distance_based]: { [transport]: [passenger_transport] },
  },
  [upstream_leased_assets]: {
    [asset_specific]: [...general_materials, transport, energy_sources],
    [average_data]: [...general_materials, transport, energy_sources],
  },
  [downstream_transportation_and_distribution]: {
    [fuel_based]: { [transport]: [freight_transport] },
    [distance_based]: { [transport]: [freight_transport] },
  },
  [processing_of_sold_products]: {
    [site_specific]: [...general_materials, energy_sources],
    [average_data]: [...general_materials],
  },
  [use_of_sold_products]: {
    [direct_use_phase]: [...general_materials, energy_sources],
    [indirect_use_phase]: [...general_materials],
  },
  [end_of_life_treatment_of_sold_products]: { [waste_type_specific]: [waste_treatment] },
  [downstream_leased_assets]: {
    [asset_specific]: [...general_materials, transport, energy_sources],
    [average_data]: [...general_materials, transport, energy_sources],
  },
};
export const organizationEmissionDetailMap = { ...supplychainEmissionDetailMap, [franchises]: {}, [investments]: {} };
export const activityBasedCategories = ["Capital Goods", "Upstream Leased Assets", "Downstream Leased Assets", "Franchises", "Investments"];

export const activityBasedData = {
  "Electricity Grid": {
    Education: 9.1,
    "Food sales": 59.0,
    "Food service": 40.6,
    "Health care": 23.4,
    Inpatient: 28.1,
    Outpatient: 17.5,
    Lodging: 14.2,
    Mercantile: 16.4,
    "Retail (other than mall)": 13.1,
    "Enclosed and strip malls": 19.3,
    Office: 13.4,
    "Public assembly": 11.4,
    "Public order and safety": 13.8,
    "Religious worship": 4.7,
    Service: 7.4,
    "Warehouse and storage": 5.8,
    Other: 31.6,
    // 'Vacant': 4.5,
  },
  "Natural Gas": {
    Education: 30.8,
    "Food sales": 71.4,
    "Food service": 167.7,
    "Health care": 58.8,
    Inpatient: 80.2,
    Outpatient: 27.5,
    Lodging: 38.9,
    Mercantile: 37.3,
    "Retail (other than mall)": 23.5,
    "Enclosed and strip malls": 46.6,
    Office: 21.1,
    "Public assembly": 40.8,
    "Public order and safety": 40.5,
    "Religious worship": 24.1,
    Service: 41.7,
    "Warehouse and storage": 17.7,
    Other: 30.5,
  },
};

export const categoryToMethodologyMap = {
  [stationary_combustion]: "https://www.epa.gov/sites/default/files/2020-12/documents/stationaryemissions.pdf",
  [mobile_sources]: "https://www.epa.gov/sites/default/files/2020-12/documents/mobileemissions.pdf",
  [refrigeration_and_fire_suppression]: "https://www.epa.gov/sites/default/files/2020-12/documents/mobileemissions.pdf",
  // "Fire Suppression": "https://www.epa.gov/climateleadership/ghg-emission-factors-hub",
  [purchased_gases]: "https://www.epa.gov/climateleadership/ghg-emission-factors-hub",
  [electricity]: "https://www.epa.gov/sites/default/files/2020-12/documents/electricityemissions.pdf",
  [steam]: "https://www.epa.gov/sites/default/files/2020-12/documents/electricityemissions.pdf",
  [business_travel]: "https://ghgprotocol.org/standards/scope-3-standard",
  [employee_commuting]: "https://ghgprotocol.org/standards/scope-3-standard",
  [upstream_transportation_and_distribution]: "https://www.epa.gov/climateleadership/scope-3-inventory-guidance",
  [downstream_transportation_and_distribution]: "https://www.epa.gov/climateleadership/scope-3-inventory-guidance",
  [purchased_goods_and_services]: "https://ghgprotocol.org/standards/scope-3-standard",
  [capital_goods]: "https://ghgprotocol.org/standards/scope-3-standard",
  [fuel_and_energy_related_activities]: "https://ghgprotocol.org/standards/scope-3-standard",
  [processing_of_sold_products]: "https://ghgprotocol.org/standards/scope-3-standard",
  [use_of_sold_products]: "https://ghgprotocol.org/standards/scope-3-standard",
  [end_of_life_treatment_of_sold_products]: "https://ghgprotocol.org/standards/scope-3-standard",
  [waste_generated_in_operations]: "https://ghgprotocol.org/standards/scope-3-standard",
  [franchises]: "https://ghgprotocol.org/standards/scope-3-standard",
  [investments]: "https://ghgprotocol.org/standards/scope-3-standard",
  [upstream_leased_assets]: "https://www.epa.gov/sites/default/files/2020-12/documents/stationaryemissions.pdf",
  [downstream_leased_assets]: "https://www.epa.gov/sites/default/files/2020-12/documents/stationaryemissions.pdf",
};
